import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'

import { DropdownMenu, useBreakpoint } from 'slab'

function UserCircleIcon (props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth='1.5'
      stroke='currentColor'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z'
      />
    </svg>
  )
}

interface ProfileDropdownProps {
  children: React.ReactNode;
  name: React.ReactNode;
}

export function ProfileDropdown ({ children, name }: ProfileDropdownProps) {
  const { breakpointIsAtLeast } = useBreakpoint()

  const isMobile = !breakpointIsAtLeast('md')

  function renderTrigger ({ open }: { open?: boolean }) {
    if (!isMobile) {
      return (
        <button className='flex items-center w-full rounded-lg p-2 pl-3 hover:bg-gray-200 data-[state*="open"]:bg-gray-200 cursor-pointer outline outline-2 outline-transparent focus-visible:outline-thatch-500'>
          <div className='w-6 h-7 flex items-center justify-start flex-shrink-0 mr-3'>
            <img
              alt='Thatch logo'
              width='131'
              height='160'
              src={RAILS_ASSET_URL('logo.png')}
            />
          </div>
          <div className='flex flex-grow items-center text-left min-w-0 mr-2'>
            <span className='leading-5 truncate'>{name}</span>
          </div>
          <div className='ml-auto size-4 flex-shrink-0 text-gray-400'>
            {open
              ? (
                <ChevronUpIcon aria-hidden size={16} />
                )
              : (
                <ChevronDownIcon aria-hidden size={16} />
                )}
          </div>
        </button>
      )
    }

    return (
      <button
        aria-label='Open user menu'
        className='appearance-none outline-2 outline-transparent focus-visible:outline-thatch-500'
      >
        <UserCircleIcon aria-hidden className='size-6 text-gray-500' />
      </button>
    )
  }
  return (
    <DropdownMenu
      trigger={renderTrigger}
      width={isMobile ? 'auto' : 'triggerWidth'}
      align={isMobile ? 'end' : 'start'}
    >
      {children}
    </DropdownMenu>
  )
}

ProfileDropdown.Item = DropdownMenu.Item
ProfileDropdown.Section = DropdownMenu.Section
